// Get all anchor tags matching 'selector' in document
const selectorApi = 'a[href^="https://api.bngguitars.com"]';
const selectorPb = 'a[href^="https://pb.bngguitars.com"]';
const linksApi = document.querySelectorAll(selectorApi);
const linksPb = document.querySelectorAll(selectorPb);

// Add rel='nofollow noindex' attribute to each
[].forEach.call(linksApi, link => {
  link.setAttribute('rel', 'nofollow noindex')
});

[].forEach.call(linksPb, link => {
  link.setAttribute('rel', 'nofollow noindex')
});

$(document).ready(function(){
  
  $('.tetrafirstoptselect').change(function(){
    var getval = $(this).find('option:selected').data('title');
    $('.tetrafinaloptselect option[data-title="'+getval+'"]').prop('selected', true);
    if($('.tetrafinaloptselect option[data-title="'+getval+'"]').data('check') == "disabled"){
      $('.template-product .add-to-cart__wrapper button.addToCart').addClass('disabled');
      $('.template-product .add-to-cart__wrapper button.addToCart').attr('disabled', 'true');
      $('.template-product .add-to-cart__wrapper button.addToCart span').text('Join Waitlist');
    }else{
      $('.template-product .add-to-cart__wrapper button.addToCart').removeClass('disabled');
      $('.template-product .add-to-cart__wrapper button.addToCart').removeAttr('disabled');
      $('.template-product .add-to-cart__wrapper button.addToCart span').text('Add to Cart');
    }
  });
  $('body').on('click','.boost-pfs-filter-option-value',function(){
    if($(this).text() == "Private Build"){
      if($(this).parents('li').find('.boost-pfs-open > a > span').text() == "Bass"){
        window.location.href = "https://pb.bngguitars.com/bass/big-sister-private-build?series=private"
      }
    }
  })
  $('.tab-navigation.tabs button').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('.tab-navigation.tabs button').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  })

  $('.boost-pfs-most-popular-products .grid-uniform').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow:true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]

  });

  $('.tetrainstockimgslider').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    adaptiveHeight: true,
    //variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          arrows:true
        }
      }
    ]
  }); 

  $('.homeslideractivator').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    adaptiveHeight: false,
    lazyLoad: 'ondemand'
  });
  
  $('.stockclosepop').click(function(){
    $('#popup-out-of-stock').hide();

    var uri = window.location.toString();
    if (uri.indexOf("?contact_posted=true") > 0) {
      var clean_uri = uri.substring(0, uri.indexOf("?contact_posted=true"));
      window.history.replaceState({}, document.title, clean_uri);
    }

  });

  $('.ipblockclosepop').click(function(){
    $('#shopify-section-ipblockpopup').hide();
  });

  $('.stockclosepop').click(function(){
    $('#popup-order-now').hide();
    $('#popup-buy-now').hide(); 
  });


  $('body').on('click','.boost-pfs-addtocart-wrapper',function(){
    $('#ContactFormproduct').val($(this).parents('.boost-pfs-filter-product-item').find('.boost-pfs-filter-product-item-title').text())
    var getdisable = $(this).find('.boost-pfs-addtocart-btn[disabled]').length;
    if(getdisable == 1){
      var getproductlink = $(this).parents('form').data('href');
      var getproducttitle = $(this).parents('.boost-pfs-filter-product-item').find('.boost-pfs-filter-product-item-title').text();
      $('form.klaviyo-form input[placeholder="Product Url"]').val(getproductlink);
      $('form.klaviyo-form input[placeholder="Product Title"]').val(getproducttitle);
      $('#popup-out-of-stock').show();
    }
  });

  $('.template-product .add-to-cart__wrapper').click(function(){
    $('#ContactFormproduct').val($('#getproducttitle').text());
    var getdisable = $(this).find('.addToCart[disabled]').length;
    if(getdisable == 1){
      var getproductlink = window.location.href;
      var getproducttitle = $("#getproducttitle").text();
      $('form.klaviyo-form input[placeholder="Product Url"]').val(getproductlink);
      $('form.klaviyo-form input[placeholder="Product Title"]').val(getproducttitle);

      $('#popup-out-of-stock').show();
    }
  });
  
  
  $('.waitlist-button').click(function(){
      $('#popup-out-of-stock').show();    
  });

  $('.customAddToCart').click(function(){
      $("#AddToCart").click();
  });

  $('.btn-crossroads').click(function(){
      $('#popup-crossroads').show();    
  });

  $('.btn-tailbar').click(function(){
      $('#popup-tailbar').show();    
  });  

  $('.btn-orchestra-popup').click(function(){
      $('#orchestraPopup').fadeIn(300);    
  });

  $('#orchestraPopupClose, .addToCart.btn-orchestra-place-order').click(function(){
    $('#orchestraPopup').fadeOut(300);
  });

  $('body').on('submit','form[action="/cart/add"]',function(e){
    e.preventDefault();
    if($('body').hasClass('regionnotallowed')){
      $('#shopify-section-ipblockpopup').show();
      return false;
    }

    $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: $(this).serialize(),
      dataType: 'json',
      success: function(line_item){
        fetchCartss();
      },
      error: function(xhr, status, error){
        console.log("Error!");
        console.log(xhr.responseText + status + error);
      }
    });
  });

  $('.addToCart.activecartbtn').click(function(e){
    e.preventDefault();
    var tempId = $(this).data('id');
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=1&id='+tempId,
      dataType: 'json',
      success: function(line_item){
        window.location.href = "/cart";
      },
      error: function(xhr, status, error) {
        console.log(xhr.responseText + status + error);
      }
    };
    $.ajax(params)
  });

  function fetchCartss() {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        console.log(cart)
        if (cart.item_count === 0) {
          $('.cartwithnoitem').removeClass('hidemessage');
          $('.cartwithnoitem').addClass('showmessage');
          $('.customdrawerinner').removeClass('showitems');
          $('.customdrawerinner').addClass('hideitems');
          $('.cartCost').addClass('hidden-count');
        } else {
          $('.cartwithnoitem').addClass('hidemessage');
          $('.cartwithnoitem').removeClass('showmessage');
          $('.customdrawerinner').addClass('showitems');
          $('.customdrawerinner').removeClass('hideitems');
          $('.cartCost').removeClass('hidden-count');
          $('.customdrawercont').html('');
          for(var i=0;i < cart.item_count;i++){
            var get_imagesrc = cart.items[i].image;
            var get_title = cart.items[i].title;
            var get_price = (cart.items[i].final_line_price / 100).toFixed(2);

            $('.customdrawercont').append('<div class="singleitem">\
<div class="singleitemimg">\
<img src="'+get_imagesrc+'"></div><div class="singleitemtitle">\
<p>'+get_title+'</p>\
<p>$'+get_price+'</p></div></div>');
          }

          $('.custommenudriwer').show();
          setTimeout(function(){
            $('.custommenudriwer').hide();
          }, 5000);
        }
      }
    });
  }



  $(".customrolling").mouseenter(function(){
    $(".customrolling").removeClass("longactive");
    $(this).addClass("longactive");
  });

  $('.customupselltop [type="checkbox"]').change(function(){
    var tempId = $(this).next().data('variant-id');
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=1&id='+tempId,
      dataType: 'json',
      success: function(line_item){
        location.reload();
      },
      error: function(xhr, status, error) {
        console.log(xhr.responseText + status + error);
      }
    };
    $.ajax(params)
  });
  $('.customtetrapopupin svg').click(function(){
    $('.customtetrapopup').hide();
  });

  /*
  $('.customAddToCart').click(function(e){
    e.preventDefault();
    $('.customtetrapopup').css('display','flex');
  });
  */

  $('.preorderbutton').click(function(){
    var tempId = $(this).data('id');
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=1&id='+tempId,
      dataType: 'json',
      success: function(line_item){
        window.location.href = "/cart";
      },
      error: function(xhr, status, error) {
        console.log(xhr.responseText + status + error);
      }
    };
    $.ajax(params)
  });

  $('.product-showcase-dropdown.product-grid-dropdown').scroll(function () {
    var offset = $('.product-showcase-dropdown.product-grid-dropdown .grid__item[data-toggle="step"]').eq(0).offset().top + 100;

    if ($(this).scrollTop() >= offset) {
      $(".addnotitle .custommenufiltert").removeClass('active');
      $(".custommenufilterin.addnotitle .custommenufiltert:nth-child(2)").addClass('active');
    }
    else{
      $(".addnotitle .custommenufiltert").removeClass('active');
      $(".custommenufilterin.addnotitle .custommenufiltert:nth-child(1)").addClass('active');
    }
  });
});

$(document).ready(function(){
  $('a[href="#collections"]').hover(function(){
    var $this = $(this);
    if(!$('.header-hamburger').is(':visible')) {
      $('div[data-id="show-dropdown"').show();
      $this.addClass('dropdown-open');
    }
    return false;
  });
  $('div[data-id="show-dropdown"]').mouseleave(function(){
    $(this).hide();
    $('.dropdown-open').removeClass('dropdown-open');
  });
  $('li[data-loop="2"]').click(function(){
    var $this = $(this),
        $target = $this.next('.dropdown-collection-list');
    if($target.length) {
      $target.show();
      return false;
    }
  });
});

$(document).on('click', '.lr-toggle', function(){
  var $this = $(this),
      $target = $this.closest('.type-check');
  if($target.hasClass('activate')) {
    $('div[data-toggle="step"]').hide();
    $('div[data-toggle="little"]').show();
    $target.removeClass('activate');
  } else {
    $('div[data-toggle="step"]').show();
    $('div[data-toggle="little"]').hide();
    $target.addClass('activate');
  }
});
$(document).on('click', '.addnotitle .custommenufiltert', function(){
  $(this).parent().find(".custommenufiltert").removeClass('active');
  $(this).addClass('active');
  var gettext = $(this).text()
  if(gettext.indexOf("LITTLE SISTER") > -1) {
    $('div[data-toggle="step"]').show();
    //$('div[data-toggle="HELENA"]').hide();
    $('div[data-toggle="little"]').show();
    $(this).parents('.custommenufilter').next().animate({
      scrollTop: $('.grid__item[data-toggle="little"]').eq(0).offset().top - 350},
                                                        'slow');
  }
  if(gettext.indexOf("Step Sister") > -1) {
    $('div[data-toggle="step"]').show();
    //$('div[data-toggle="HELENA"]').hide();
    $('div[data-toggle="little"]').show();
    $(this).parents('.custommenufilter').next().animate({
      scrollTop: $('.grid__item[data-toggle="step"]').eq(0).offset().top - 350},
                                                        'slow');
  }
});

$(document).on('click', '.addnewtitle .custommenufiltert', function(){
  $(this).parent().find(".custommenufiltert").removeClass('active');
  $(this).addClass('active');
  var gettext = $(this).text()
  if(gettext.indexOf("LITTLE SISTER") > -1) {
    $('div[data-toggle="little-standard"]').show();
    //$('div[data-toggle="HELENA"]').hide();
    $('div[data-toggle="little"]').show();
    $(this).parents('.custommenufilter').next().animate({
      scrollTop: $('.grid__item[data-toggle="little-standard"]').eq(0).offset().top - 350},
                                                        'slow');
  }
  if(gettext.indexOf("Helena") > -1) {
    $('div[data-toggle="helena"]').show();
    //$('div[data-toggle="HELENA"]').hide();
    $('div[data-toggle="helena"]').show();
    $(this).parents('.custommenufilter').next().animate({
      scrollTop: $('.grid__item[data-toggle="helena"]').eq(0).offset().top - 350},
                                                        'slow');
  }
});


$(document).ready(function(){
  var maxLength = $('.word-limit').val();
  if(maxLength == null) {
    maxLength = 128;
  }
  if($('.product-bottom-details .product-page .wrapper .product-top-container .product-description').length) {
    $(".product-bottom-details .product-page .wrapper .product-top-container .product-description").each(function(){
      var myStr = $(this).text();
      if($.trim(myStr).length > maxLength){
        var newStr = myStr.substring(0, maxLength);
        console.log($.trim(myStr).length);
        var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
        $(this).empty().html(newStr);
        $(this).append('<span class="more-text">' + removedStr + '</span>');
        $(this).append(' <a href="javascript:void(0);" class="read-more">read more</a><a style="display:none;" href="javascript:void(0);" class="read-less">read less</a>');
      }
    });
  }
  if($('.product-bottom-details .product-page .wrapper .product-top-container .product-description').length) {
    $(".product-bottom-details .product-page .wrapper .product-top-container .product-description").each(function(){
      var myStr = $(this).text();
      if($.trim(myStr).length > maxLength){
        var newStr = myStr.substring(0, maxLength);
        console.log($.trim(myStr).length);
        var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
        $(this).empty().html(newStr);
        $(this).append('<span class="more-text">' + removedStr + '</span>');
        $(this).append(' <a href="javascript:void(0);" class="read-more">read more</a><a style="display:none;" href="javascript:void(0);" class="read-less">read less</a>');
      }
    });
  }
  $(".read-more").click(function(){
    $(this).siblings(".more-text").show();
    $(this).closest('div').find('.read-less').show();
    $(this).hide();
  });
  $("span.tetralessdes").click(function(){
    $('p.detailsshowless').hide();
    $('p.detailsshowmore').show();
  });
  $("span.tetramoresdes").click(function(){
    $('p.detailsshowless').show();
    $('p.detailsshowmore').hide();
  });
  $('.read-less').click(function(){
    var $this = $(this),
        $target = $this.closest('div'),
        $offset = $target.offset().top;
    if($this.closest('.section-crossroads').lenght < 0) {
      $(window).scrollTop($offset);
    }
    $(this).closest('div').find(".more-text").hide();
    $(this).closest('div').find('.read-more').show();
    $(this).hide();
  });
  
});



$(window).on('load', function(){
  if($('.fadeInUp').length) {
    $('.fadeInUp').addClass('show-text-now');
  }
});

$(document).on('click', 'a[data-popup]', function(){
  var $target = $(this).data('popup');
  $('.' + $target).show();
  $('html').addClass('blockOverflow');
});

$(document).on('click', '.close-popup', function(){
  $(this).closest('.image-popup').hide();
  $('html').removeClass('blockOverflow');
});

$(window).on('scroll', function(){
  $('.fadeTextIn').each(function(){
    var $this = $(this),
        $scrollAmount = $(window).scrollTop(),
        $offset = $this.offset().top,
        $windowHeight = $(window).height() / 2;
    $offset = $offset - $windowHeight;
    if($offset <= $scrollAmount) {
      $this.addClass('fadeInTextNow');
    }
  });
});

$(document).on('click', '.sticky-bar .nav-bar-product a', function(){
  var $this = $(this);
  $('.sticky-bar .nav-bar-product a.active-item').removeClass('active-item');
  $this.addClass('active-item');
  $text = $this.text();
  $('.nav-bar-product-trigger').html($text);
});

$(document).on('click', '.addtocart-trigger', function(){
  $('.add-to-cart__wrapper button').trigger('click');
});

var lastScrollTop = 0;
$(window).scroll(function(event){
  var st = $(this).scrollTop();
  if($('#overview').length) {
    $limit = $('#overview').offset().top;	
    if(st > $limit) {
      $('#shopify-section-header').addClass('scroll-started');
    } else {
      $('#shopify-section-header').removeClass('scroll-started');
    }
  }
  if (st > lastScrollTop){
    $('.scroll-started').removeClass('show-on-top');
  } else {
    $('.scroll-started').addClass('show-on-top');
  }
  lastScrollTop = st;
  $('.nav-item-check').each(function(){
    var $this = $(this),
        $offset = $this.offset().top;
    if(st > $offset) {
      var $id = $this.attr('id');
      $id = '#' + $id;
      $('.sticky-bar .nav-bar-product a').removeClass('active-item');
      $('.sticky-bar .nav-bar-product a[href="' + $id + '"]').addClass('active-item');
      $text = $('.sticky-bar .nav-bar-product a[href="' + $id + '"]').text();
      $('.nav-bar-product-trigger').html($text);
    }
  });
  if(st > 0) {
    $('.sticky-bar .nav-form').addClass('show-from-bottom');
  } else {
    $('.sticky-bar .nav-form').removeClass('show-from-bottom');
  }
});

$(document).on('click', '.nav-bar-product-trigger', function(){
  $('.nav-bar-product').addClass('show-nav');
});

$(document).on('click', 'body', function(e){
  if(!$(e.target).closest(".nav-bar-product-trigger").length > 0) {
    $('.nav-bar-product').removeClass('show-nav');
  }
});

$(document).on('click', '.playCustom', function(){
  var $this = $(this);
  $this.closest('.video-thumbnail').hide();
  $this.closest('.champagne-video-container').find('.responsive-video-container').show();
  if( $this.closest('.champagne-video-container').find('.video-embed').length ) {
    var $id = $this.closest('.champagne-video-container').find('.video-embed').data('id');
    var $divID = $this.closest('.champagne-video-container').find('.video-embed').attr('id');
    player = new YT.Player($divID, {
      width : '320',
      height : '180',
      videoId : $id,
      playerVars: { 'autoplay': 1 },
      events : {
        'onReady' : onPlayerReady,
        'onStateChange' : onPlayerStateChange
      }
    });
  } else {
    var $id = $this.closest('.champagne-video-container').find('.responsive-video-container iframe').attr('id');
    iframe = document.getElementById($id);
    var player = $f(iframe);
    player.api("play");
  }
});

var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var player;
function onPlayerReady(event) {
  //event.target.playVideo();
}
function onPlayerStateChange(event) {
  if(event.data == YT.PlayerState.ENDED) {
    player.destroy();
  }
}

$(document).on('click', '.product-page .qty-plus', function(){
  var $this = $(this),
      $target = $this.parent().find('input'),
      $val = parseInt($target.val()) + 1;
  $target.val($val).trigger('change');
});

$(document).on('click', '.product-page .qty-minus', function(){
  var $this = $(this),
      $target = $this.parent().find('input'),
      $val = parseInt($target.val()) - 1;
  if($val > 0) {
    $target.val($val).trigger('change');
  }
});

$(document).on('click', '.acc-spec-title', function(){
  $(this).next('div').slideToggle();
  $(this).toggleClass('active');
});
$(document).on('click', '.master-spec-title', function(){
  $(this).next('div').slideToggle();
  $(this).toggleClass('active');
});
$(document).on('click', '.stockin-spec-title', function(){
  $(this).next('div').slideToggle();
  $(this).toggleClass('active');
});

$(document).on('click', '.desc-read-more', function(){
  var $this = $(this),
      $target = $this.closest('.product-description'),
      $show = $target.next('.product-description');
  $target.hide();
  $show.show();
});

$(document).on('click', '.customsmalldes span.showmore', function(){
  $(this).parents('.customsmalldes').hide();
  $(this).parents('.customsmalldes').next().show();

});
$(document).on('click', '.customlargdes span.showmore', function(){
  $(this).parents('.customlargdes').hide();
  $(this).parents('.customlargdes').prev().show();

});


$(document).on('click', '.desc-read-less', function(){
  var $this = $(this),
      $target = $this.closest('.product-description'),
      $show = $target.prev('.product-description');
  $target.hide();
  $show.show();
});

$(document).on('change', '.finish-option-select', function(){
  var $val = $(this).val();
  window.location = $val;
});


$(document).ready(function(){
  $.ajax({
    type: 'GET',
    url: 'https://api.ipgeolocation.io/ipgeo?apiKey=add731f5e120458d89492a6437294445',
    dataType: 'json',
    success: function(location) {
      //console.log(location);
      let notAllowedCountries = ['PL', 'CZ', 'FR', 'ES', 'SK', 'HU', 'DE', 'NL', 'BE', 'LU', 'AT', 'CH'];

      if(notAllowedCountries.indexOf(location.country_code2) == -1) {  
        $('body').removeClass('regionnotallowed');
      } 
            
      if(location.country_code2 == 'US' || location.country_code2 == 'IL' ){
        //$('.vslideractivator').remove();
        //$('.customusaslider').show();
      }
    }
  });

});


// 4TH JULY SALES POPUP 
/*
$(document).ready(function(){
  
  $('#sales-popup').delay(1500).fadeIn(300);
  
  $('#sales-popup .popup-close').click(function() {
    $('#sales-popup').fadeOut(300);
  });

});
*/

// Countdown timer
$(document).ready(function(){
  function makeTimer() {

      //	var endTime = new Date("29 April 2018 9:56:00 GMT+01:00");	
      var endTime = new Date(themeVariables.timerDate);			
      endTime = (Date.parse(endTime) / 1000);

      var now = new Date();
      now = (Date.parse(now) / 1000);

      var timeLeft = endTime - now;

      var days = Math.floor(timeLeft / 86400); 
      var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
      var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
      var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

      if (hours < "10") { hours = "0" + hours; }
      if (minutes < "10") { minutes = "0" + minutes; }
      if (seconds < "10") { seconds = "0" + seconds; }

      $("#timer-days").html(days);
      $("#timer-hours").html(hours);
      $("#timer-minutes").html(minutes);
      $("#timer-seconds").html(seconds);	
  
  }

  setInterval(function() { makeTimer(); }, 1000);

});

// Amp link
$(document).bind('DOMSubtreeModified', function () {

  var checkExist = setInterval(function() {
     if ($('a.boost-pfs-filter-product-item-image-link').length) {
        clearInterval(checkExist);

        $(".boost-pfs-filter-product-item-image-link").each(function(){

          if ( $(this).attr('href') == "/collections/all/products/b-g-prototype-amp" || $(this).attr('href') == "/collections/amps/products/b-g-prototype-amp" || $(this).attr('href') == "/products/b-g-prototype-amp") {
            $(this).attr('href', 'https://pb.bngguitars.com/amp/prototype-amp');
          }
          
        });
       
     }
  }, 50);
  
});


// Footer collapsible tab
$(document).ready(function() {
  $(".collapsible").click(function(event) {
    $(this).next().toggle();
    $(this).find(".plus").toggle();
  });
});


/* ====================== Cleaned up scripts ====================== */
// Back to top button
$(document).ready(function(){
  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 150) {
      $('#back-to-top').addClass('active');
    } else {
      $('#back-to-top').removeClass('active');
    }
  });

  $('#back-to-top').on('click', function(e) {
    $("html, body").animate({scrollTop: 0}, 600);
  });
});  


// Highlights slider (solved)
$(document).ready(function(){
  $('.standard-product-slider').each(function(){
    $(this).slick({
      arrows: true,
      dots: true,
      appendDots: $(this).parent().find('.slick-slider-dots'),
      prevArrow: $(this).parent().find('.prev'),
      nextArrow: $(this).parent().find('.next'),
      autoplay: false,
      autoplaySpeed: 8000,
      lazyLoad: 'progressive',
      pauseOnFocus: false,
      pauseOnHover: false,
      adaptiveHeight: false
    });
  });
});

// Product tabs (solved)
$(document).on('click', '.product-tabs-link a', function(){
  var $this = $(this),
      $target = $this.data('tab-id');
 if(!$this.hasClass('active')) {
    $this.closest('.product-tabs-link').find('.active').removeClass('active');
    $this.addClass('active');
    $this.closest('.product-tabs').find('.product-tabs-row.active').removeClass('active');
    $($target).addClass('active');
  }
});

// Orientation swatch & InStock / Deposit variants
$(document).ready(function(){

  $('.addtocart-trigger').text($('#AddToCartText').text());
  
  $('.orientation-swatch').on('click', function(){
    // set active selector
    $(this).siblings().removeClass('active');
    $(this).addClass('active');

    // change variant selector value
    let selectedValue = $(this).data('value');
    $('select.guitar-variants').find('option[data-value*="' + selectedValue + '"]').prop('selected',true).trigger('change');

    // change atc button text and popup data
    let btnText = $('select.guitar-variants').find('option[data-value*="' + selectedValue + '"]').data('buttontext');
    let popupData = $('select.guitar-variants').find('option[data-value*="' + selectedValue + '"]').data('popup');
    $('#AddToCart').attr('data-popup', '' + popupData +'');
    //$('#AddToCartText, .addtocart-trigger').text('' + btnText + '');
    
  });

  // swap image on select change
  $('select.guitar-variants').on('change', function() {
    $('.guitar-hero-image').attr('src', $(this).find(":selected").data('img'));
  });

  // open popups
  $('#AddToCart').on('click', function() {
    // open popup
    //console.log($(this).attr('data-popup'));   
    $('#' + $(this).attr('data-popup') + '').show();    
  });

});



/* Register form */
$( document ).ready(function() {  
  $('#ContactFormReferral').on('change', function() {
    if ( $(this).val() == 'Store' || $(this).val() == 'Other' ) {
      $('.specify-referral').removeClass('hidden');
      $('#ContactFormReferralSpec').prop('required', true);
    } else {
      $('.specify-referral').addClass('hidden');
      $('#ContactFormReferralSpec').prop('required', false);
    }
  }); 

   $('#ContactFormPurchase').on('change', function() {
    if ( $(this).val() == 'Online Store' || $(this).val() == 'Brick and Mortar Store' || $(this).val() == 'Other' ) {
      $('.specify-purchase').removeClass('hidden');
      $('#ContactFormPurchaseSpec').prop('required', true);
    } else {
      $('.specify-purchase').addClass('hidden');
      $('#ContactFormPurchaseSpec').prop('required', false);
    }
  });  
}); 
